import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {Col, Row} from "react-bootstrap";
import {Input, Label, UncontrolledTooltip} from "reactstrap";
import Select from "../../local_node_modules/react-select";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import Alert from "react-s-alert";
import {validateField} from "../../common/validation"

class CreateEditCustomerRequestModal extends Component {
    constructor(props) {
        super(props);
        this.state ={
            services: [],
            requestForm:{
                subject:"",
                subjectType:"",
                receiverId:null,
                requestType:"general",
                relatedCustomerVknTckn:"",
                email:"",
                phone:""
            },
            assignees: [],
            type:"",
            error: {}
        }
        this.saveRequest = this.saveRequest.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.fetchService = this.fetchService.bind(this);
        this.onRequestChange = this.onRequestChange.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.fetchAssignees = this.fetchAssignees.bind(this);
        this.validateField 	= this.validateField.bind(this);
    }
    componentWillMount() {
        if(this.props.type === "edit"){
            let requestForm = this.props.selectedRequest;
            this.setState({requestForm});
        }
    }

    componentDidMount() {
        this.fetchService();
        this.fetchAssignees();
    }

    closeModal(){
        this.props.closeModal(false);
    }

    fetchService() {
        let self = this;
        let params = {
            url: "/requestForm/getServices",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let services = response.data;
                services.push({ublCode: "Diğer", ublName: "DIGER"});
                self.setState({services});
            }).catch(function (error) {
            showAxiosError(error);
        }).then(function () {
            self.setState({loading: false});
        });
    }
    onRequestChange(data) {
        let self = this;
        let requestForm = self.state.requestForm;
        requestForm[data.name] = data.value;
        self.setState({requestForm});
    }

    saveRequest() {
        let self = this;
        let requestForm = self.state.requestForm;
        let type = self.props.type;
        let params = {
            url: '/requestForm/save',
            method: "post",
            data: requestForm
        };
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                let requestForm = response.data.requestForm;
                self.setState({
                    requestForm,
                    loading: false,
                });
                if(type === "create"){
                    Alert.success('İsteğiniz başarılı bir şekilde kaydedilmiştir.', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                }
                else{
                    Alert.success('İsteğiniz başarılı bir şekilde güncellenmiştir.', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000
                    });
                }


                self.props.closeModal(type === "create", requestForm);
            }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });
    }

    fetchAssignees() {
        let self = this;
        let params = {
            url: "/user/getUserBySelectedRole",
            method: "get",
        };
        request(params).then(function (response) {
            self.setState({assignees: response.data});
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }
    isEnabledSave(){
        let self = this;
        let error = self.state.error;
        const requestForm = self.state.requestForm;
        const fields = Object.keys(error);
        let disabled = false;
        if(requestForm){
            if(requestForm.requestType === "customer"  && requestForm.relatedCustomerVknTckn.length === 0)
                disabled = true;
            else if(requestForm.email.length === 0 || requestForm.phone.length === 0)
                disabled = true;
            else if(fields.length>0)
                fields.forEach(field => {if(!error[field].valid)disabled=true})
            else{
                if(self.props.type === "edit"){
                    disabled = false;
                }else
                    disabled = true;
            }
        }else
            disabled = true;
        return disabled;
    }

    render() {
        return (
            <DefaultModal
                disabled={this.isEnabledSave()}
                isOpen={this.props.modal}
                title="İstek/Talep"
                size="lg"
                confirmBtnText={this.props.type === "create"? "Oluştur" : "Güncelle"}
                cancelBtnText="Kapat"
                onConfirm={this.saveRequest}
                onCancel={this.closeModal}
            >
                <Col sm="12">
                    <Col sm="12" className="p-2" style={{border: "2px solid #e7e7e7", borderRadius: "6px 6px 6px 6px"}}>
                        <h2>Talep Bilgileri</h2>
                        <Row>
                            <Col sm="12">
                                <Row>
                                    <Col sm="3" lg="2">
                                       <Label>Talep Türü:</Label>
                                    </Col>
                                    <Col sm="9" lg="4">
                                        <Select
                                            clearable={false}
                                            placeholder="Tür Seçiniz.."
                                            noResultsText="Kayıt Bulunamadı.."
                                            className="select-control"
                                            value={this.state.requestForm.requestType}
                                            onChange={(e) => e && this.onRequestChange({
                                                name: "requestType",
                                                value: e.value
                                            })}
                                            options={[
                                                {label:"Genel Talep", value:"general"},
                                                {label: "Müşteri Talebi", value:"customer"}
                                            ]}
                                        />
                                    </Col>
                                    <Col sm="3" lg="2">
                                        <Label>Konu Tipi:</Label>
                                    </Col>
                                    <Col sm="9" lg="4">
                                        <Select
                                            clearable={false}
                                            placeholder="Konu Seçiniz.."
                                            noResultsText="Kayıt Bulunamadı.."
                                            className="select-control"
                                            value={this.state.requestForm.subjectType}
                                            onChange={(e) => e && this.onRequestChange({
                                                name: "subjectType",
                                                value: e.value
                                            })}
                                            options={this.state.services.map(service => ({
                                                value: service.ublName,
                                                label: service.ublCode
                                            }))}
                                        />
                                    </Col>
                                </Row>

                                <Row>

                                    {this.props.currentUser.vknTckn === '5750464002' &&

                                    <Col sm="3" lg="2">
                                        <Label>Atanan Kişi:</Label>
                                    </Col>}
                                    {this.props.currentUser.vknTckn === '5750464002' &&
                                    <Col sm="9" lg="4">
                                        <Select
                                            disabled={!this.props.currentUser.adminUser}
                                            clearable={false}
                                            placeholder="Kişi Seçiniz.."
                                            noResultsText="Kayıt Bulunamadı.."
                                            className="select-control"
                                            value={this.state.requestForm.receiverId}
                                            onChange={(e) => e && this.onRequestChange({
                                                name: "receiverId",
                                                value: e.value
                                            })}
                                            options={this.state.assignees.map(assignee => ({
                                                value: assignee.recordId,
                                                label: assignee.firstName + " " + assignee.lastName
                                            }))}
                                        />
                                    </Col>
                                    }

                                </Row>
                                <Row>
                                    <Col sm="3" lg="2">
                                        <Label>Konu:</Label>
                                    </Col>
                                    <Col sm="9" lg="10" className={"form-group" + this.validateClass("tSubject")}>
                                        <Input className="form-control"
                                               type="text"
                                               data-vlength="1,255"
                                               data-vdata="subject"
                                               id="tSubject"
                                               name="subject"
                                               onBlur={(e) => this.validateField(e)}
                                               autoComplete={"false"}
                                               value={this.state.requestForm.subject}
                                               onChange={(e) => this.onRequestChange({
                                                   name: "subject",
                                                   value: e.target.value
                                               })}/>
                                        {this.validateMessage('tSubject') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tSubject"
                                                             delay={0}>
                                            {this.validateMessage("tSubject")}
                                        </UncontrolledTooltip>}
                                    </Col>


                                </Row>

                            </Col>
                        </Row>
                    </Col>
                    <br/>
                    <Col sm="12" className="p-2" style={{border: "2px solid #e7e7e7", borderRadius: "6px 6px 6px 6px"}}>
                        <h2>Diğer Bilgiler</h2>
                        <Row>
                            <Col sm="12">
                                <Row>
                                    <Col sm="3" lg="2">
                                        <Label>E-Posta:</Label>
                                    </Col>
                                    <Col sm="9" lg="4" className={"form-group" + this.validateClass("email")}>
                                        <Input className="form-control"
                                               type="text"
                                               data-vlength="1,255"
                                               data-vdata="email"
                                               id="email"
                                               name="email"
                                               onBlur={(e) => this.validateField(e)}
                                               autoComplete={"false"}
                                               value={this.state.requestForm.email}
                                               onChange={(e) => this.onRequestChange({
                                                   name: "email",
                                                   value: e.target.value
                                               })}/>
                                        {this.validateMessage("email") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"email"} delay={0}>
                                            {this.validateMessage("email")}
                                        </UncontrolledTooltip>}
                                    </Col>

                                    <Col sm="3" lg="2">
                                        <Label>Telefon:</Label>
                                    </Col>
                                    <Col sm="9" lg="4" className={"form-group" + this.validateClass("phone")}>
                                        <Input className="form-control"
                                               type="text"
                                               data-vlength="10,11"
                                               data-vdata="phone"
                                               id="phone"
                                               name="phone"
                                               onBlur={(e) => this.validateField(e)}
                                               autoComplete={"false"}
                                               value={this.state.requestForm.phone}
                                               onChange={(e) => this.onRequestChange({
                                                   name: "phone",
                                                   value: e.target.value
                                               })}/>
                                        {this.validateMessage("phone") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"phone"} delay={0}>
                                            {this.validateMessage("phone")}
                                        </UncontrolledTooltip>}
                                    </Col>

                                </Row>

                                {
                                    this.state.requestForm.requestType === "customer" &&
                                    <Row>
                                        <Col sm="3" lg="2">
                                            <Label>Vkn/Tckn:</Label>
                                        </Col>
                                        <Col sm="9" lg="4" className={"form-group" + this.validateClass("tVknTckn")}>
                                            <Input className="form-control"
                                                   maxLength="11"
                                                   type="text"
                                                   name="vknTckn"
                                                   id="tVknTckn"
                                                   data-vlength="10,11"
                                                   data-vdata="identifier"
                                                   onBlur={(e) => this.validateField(e)}
                                                   ref="tVknTckn"
                                                   autoComplete={"false"}
                                                   value={this.state.requestForm.relatedCustomerVknTckn}
                                                   onChange={(e) => this.onRequestChange({
                                                       name: "relatedCustomerVknTckn",
                                                       value: e.target.value
                                                   })}/>
                                            {this.validateMessage('tVknTckn') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tVknTckn"
                                                                 delay={0}>
                                                {this.validateMessage("tVknTckn")}
                                            </UncontrolledTooltip>}
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                    <br/>
                </Col>

            </DefaultModal>
        );
    }
}

export default CreateEditCustomerRequestModal;